<div class="search-no-results-container">
    <div class="no-results-header" *ngIf="!searchNoResults?.fastNoResult; else fastNoResult">
        <h2 class="no-results-title">{{ searchNoResults?.title }}</h2>
        <div class="no-results-image">
            <finder-picture *ngIf="searchNoResults?.image" [picture]="image" class="fit"></finder-picture>
        </div>
    </div>

    <ng-template #fastNoResult>
        <div class="no-results-header-image">
            <finder-picture *ngIf="noResultsPage.headerImage" [picture]="noResultsPage.headerImage" class="fit"></finder-picture>
        </div>
        <finder-component-header *ngIf="noResultsPage.headerData"
            [data]="noResultsPage.headerData">
        </finder-component-header>
        <finder-generic-text [data]="noResultsPage.genericText">
        </finder-generic-text>
        <finder-content-header *ngIf="noResultsPage.popularSearches"
            [headerData]="noResultsPage.popularSearches">
        </finder-content-header>
        <div class="searches" *ngIf="noResultsPage.popularSearches?.links">
            <finder-anchor 
                *ngFor="let link of noResultsPage.popularSearches.links"
                [ariaLabel]="link.title"
                [href]="link.href"
                [title]="link.title">
                {{link.title}}
            </finder-anchor>
        </div>
        <div class="image-block-wrapper no-link">
            <finder-image-block *ngIf="noResultsPage.blockData" class="search-no-results-block"
                [blockData]="noResultsPage.blockData"
            ></finder-image-block>
        </div>
    
    </ng-template>
</div>
